import React, { useContext, useState } from "react";
import { withRouter } from "react-router-dom";
import { CdrGlobalContext } from "../../../context/cdrGlobalContext";
import { UPDATE_BUSCADOR_HOTELES, UPDATE_FECHA_IN_HOTELES } from "../../../context/constantes";
import {
  convertirHabitacionesAParam,
  deJSAFechaAmericana,
  sumarFechaEnJSYDevolverBase,
} from "../../../utils/Tools";
import CuadroHabitaciones from "./cuadroHabitaciones";

const BuscadorHotel = (props) => {
  const { isResultados = false, estilos } = props;
  const [state, dispatch] = useContext(CdrGlobalContext);
  const { provinciasParaHoteles, busquedaCDR } = state || {};
  // const [totalPasajeros, setTotalPasajeros] = useState("1 adultos");
  const [showDivPasajeros, setShowDivPasajeros] = useState(isResultados);
  const [mensaje, setMensaje] = useState('');

  const handleComboSelectedForm = (e) => {
    dispatch({type: UPDATE_BUSCADOR_HOTELES, payload: {name: e.target.name, value: e.target.value}})
  };

  const handleFechaIn = (e) => {
    dispatch({type: UPDATE_FECHA_IN_HOTELES, payload: {value: e.target.value}})
  };
 
  const formIsValid = (busquedaCDR) => {
    if (
      busquedaCDR.destino === "" || busquedaCDR.destino === "0" ||
      busquedaCDR.fechaIn === "" ||
      busquedaCDR.fechaOut === "" ||
      busquedaCDR.habitaciones.length === 0
    ) {
      setMensaje('Debe completar todos los campos');
      return false;
    }
    setMensaje('');
    return true;
  };

  const handleClikBuscarHoteles = (e) => {
    e.preventDefault();
    if (!formIsValid(busquedaCDR)) return;
    const habitacionString = convertirHabitacionesAParam(
      busquedaCDR.habitaciones
    );

    props.history.push(
      `/hoteles/listado-de-hoteles/${busquedaCDR.destino}/${busquedaCDR.fechaIn}/${busquedaCDR.fechaOut}/${habitacionString}`
    );
  };

  //busquedaCDR: {destino: '', fechaIn: '', fechaOut: '', habitaciones: 1, adultos: 2, menores: ['2', '8']}

  return (
          <form className="form-row">
              <div className={`input-container ${estilos.estilosDestinos}`}>
                <label className="labelHotel">Destinos</label>
                <select
                  className="formControlBuscarHotel"
                  name="destino"
                  value={busquedaCDR.destino}
                  onChange={handleComboSelectedForm}
                  placeholder="Selecciona el Destino"
                >
                  <option value="0">Seleccione un destino</option>
                  {provinciasParaHoteles.map(prov => {
                    return (
                      <option key={prov.codigo} value={prov.codigo}>
                        {prov.denominacion}
                      </option>
                    );
                  })}
                </select>
              </div>
                <div className={`input-container ${estilos.estilosInputs}`}>
                  <label className="labelHotel" htmlFor="fechaIn">
                    Fecha In
                  </label>
                  <input
                    className="formControlBuscarHotel"
                    type="date"
                    min={deJSAFechaAmericana(new Date())}
                    name="fechaIn"
                    id="fechaIn"
                    placeholder="In"
                    value={busquedaCDR.fechaIn}
                    onChange={handleFechaIn}
                    required
                  />
                </div>
                <div className={`input-container ${estilos.estilosInputs}`}>
                  <label className="labelHotel" htmlFor="fechaOut">
                    Fecha Out
                  </label>
                  <input
                    className="formControlBuscarHotel"
                    type="date"
                    min={sumarFechaEnJSYDevolverBase(new Date(busquedaCDR.fechaIn), 4)}
                    name="fechaOut"
                    id="fechaOut"
                    placeholder="Out"
                    value={busquedaCDR.fechaOut}
                    onChange={handleComboSelectedForm}
                    required
                  />
                </div>

              <div className={`input-container ${estilos.estilosDestinos}`}>
                <label className="labelHotel" htmlFor="cantidadHabitaciones">
                  Cantidad Habitaciones
                </label>

                <input
                  type="text"
                  readOnly=""
                  className="formControlBuscarHotel dropdownHotelHabitacion"
                  placeholder={`${busquedaCDR.habitaciones.length} ${
                    busquedaCDR.habitaciones.length === 1
                      ? "Habitación"
                      : "Habitaciones"
                  }`}
                  onClick={() => setShowDivPasajeros(!showDivPasajeros)}
                />

                {showDivPasajeros && (
                  <CuadroHabitaciones
                    habitaciones={busquedaCDR.habitaciones}
                    dispatch={dispatch}
                    setShowDivPasajeros={setShowDivPasajeros}
                    isResultados={isResultados}
                  />
                )}
              </div>

              <div className={estilos.estiloBoton}>
                <span className="formError">{mensaje}</span>
                <input
                  className="botonBuscarHotel"
                  type="submit"
                  value="Buscar"
                  onClick={handleClikBuscarHoteles}
                />
              </div>
          </form>
  );
};

export default withRouter(BuscadorHotel);



// WEBPACK FOOTER //
// ./src/components/Hoteles/BuscadorHotel/index.js